module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/start_quote-af77817cc3b54dbe3cdd909f0225dfcf.png";